/**
 * Register metrics exporters from environment (backend + shared).
 */

import {
  createLoggerMetricsExporter,
  createOtlpHttpMetricsExporter,
  createSentryBreadcrumbExporter,
  flushMetrics,
  registerMetricsExporter,
} from './metrics-exporters';

let bootstrapped = false;
let flushIntervalId: ReturnType<typeof setInterval> | undefined;

function envTruthy(value: string | undefined): boolean {
  if (!value) return false;
  const v = value.trim().toLowerCase();
  return v === '1' || v === 'true' || v === 'yes';
}

export function bootstrapMetricsExporters(): void {
  if (bootstrapped) return;
  bootstrapped = true;

  if (envTruthy(process.env.METRICS_FLUSH_LOG)) {
    registerMetricsExporter(createLoggerMetricsExporter());
  }

  const otlpEndpoint =
    process.env.METRICS_OTLP_HTTP_ENDPOINT?.trim() ||
    process.env.OTEL_EXPORTER_OTLP_METRICS_ENDPOINT?.trim();
  if (otlpEndpoint) {
    registerMetricsExporter(createOtlpHttpMetricsExporter(otlpEndpoint));
  }

  if (typeof window !== 'undefined') {
    registerMetricsExporter(createSentryBreadcrumbExporter());
  }

  const intervalMs = Number.parseInt(process.env.METRICS_FLUSH_INTERVAL_MS ?? '60000', 10);
  if (intervalMs > 0 && typeof setInterval !== 'undefined') {
    flushIntervalId = setInterval(() => flushMetrics(), intervalMs);
    if (typeof flushIntervalId === 'object' && 'unref' in flushIntervalId) {
      flushIntervalId.unref();
    }
  }
}

export function stopMetricsFlushIntervalForTests(): void {
  if (flushIntervalId !== undefined) {
    clearInterval(flushIntervalId);
    flushIntervalId = undefined;
  }
  bootstrapped = false;
}
